import { LazyQueryExecFunction } from '@apollo/client/react';
import {
  SiteArea,
  SiteAreaFilterInputObject,
  SiteAreasSearchListQuery,
  SiteAreasSearchListQueryVariables,
  SortDirectionEnum,
  FilterGroupingEnum,
} from 'graphql-common';
import { DEFAULT_SEARCH_LIST_VARIABLES } from '@lib/enums/urls';
import getLoadOptionsResult from '@lib/utils/getLoadOptionsResult';
import createSearchFilters, {
  defaultSearchListSchema,
} from '@lib/utils/createSearchFilters';
import { LoadOptionsParams } from '@lib/components/Select/types';

type FetchLazyQuery = LazyQueryExecFunction<
  SiteAreasSearchListQuery,
  SiteAreasSearchListQueryVariables
>;

export const fetchSearchList = async (
  searchQuery: string,
  fetchLazyQuery: FetchLazyQuery,
  page: number,
  siteId?: string,
) => {
  const options: { variables: SiteAreasSearchListQueryVariables } = {
    variables: {
      ...DEFAULT_SEARCH_LIST_VARIABLES,
      page,
      sorts: { name: SortDirectionEnum.Asc },
    },
  };
  const filters: SiteAreaFilterInputObject[] = [];
  if (searchQuery) {
    filters.push(...createSearchFilters(searchQuery, defaultSearchListSchema));
  }
  if (siteId) {
    filters.push({
      siteId: {
        grouping: FilterGroupingEnum.And,
        predicate: { eq: siteId },
      },
    });
  }
  if (filters.length && options.variables) {
    options.variables.filters = filters;
  }
  const { data } = await fetchLazyQuery(options);
  return getLoadOptionsResult(
    data,
    (dataItem: SiteArea) => ({
      value: dataItem.id,
      label: dataItem.name,
      data: dataItem,
    }),
    searchQuery,
  );
};

export const getSiteAreasLoadOptions =
  (fetchLazyQuery: FetchLazyQuery, siteId?: string) =>
  (searchQuery: string, _loadedOptions: unknown, params: LoadOptionsParams) =>
    fetchSearchList(searchQuery, fetchLazyQuery, params?.page || 1, siteId);
